import { motion, AnimatePresence } from 'framer-motion';

const TrackingBanner = ({ title, description, image }) => {
  const imageSrc = typeof image === 'string' ? image : image?.default || image;

  // Highlight the word "Tracking" in primary teal (#067978) while keeping other text as-is
  const renderTitle = () => {
    if (typeof title === 'string' && /tracking/i.test(title)) {
      const parts = title.split(/(tracking)/i);
      return (
        <>
          {parts.map((part, index) =>
            part.toLowerCase() === 'tracking' ? (
              <span key={index} className="text-[#067978]" style={{ fontWeight: 800 }}>
                {part}
              </span>
            ) : (
              <span key={index} className="text-slate-900" style={{ fontWeight: 800 }}>
                {part}
              </span>
            )
          )}
        </>
      );
    }
    return title;
  };

  return (
    <div
      className="relative w-full h-[200px] md:h-[240px] lg:h-[260px] rounded-3xl overflow-hidden mb-8 shadow-sm bg-white border-[1.5px] border-[#067978]/25"
      style={{ borderWidth: '1.5px', borderColor: 'rgba(6, 121, 120, 0.25)', borderStyle: 'solid' }}
    >
      {/* Background Image - Seamless Cross-Fade */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <AnimatePresence initial={false}>
          {imageSrc && (
            <motion.div
              key={imageSrc}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35, ease: 'easeInOut' }}
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url(${imageSrc})`
              }}
            />
          )}
        </AnimatePresence>
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col justify-center px-6 md:px-10 lg:px-14 max-w-xl md:max-w-2xl z-10">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.22, ease: 'easeOut' }}
          >
            <h1
              className="text-2xl sm:text-3xl md:text-4xl lg:text-[40px] font-extrabold text-slate-900 mb-2 tracking-tight leading-tight"
              style={{ fontWeight: 800 }}
            >
              {renderTitle()}
            </h1>
            <p
              className="text-slate-700 text-xs sm:text-sm md:text-base max-w-lg leading-relaxed font-semibold border-l-4 border-[#067978] pl-3.5 mt-2"
              style={{ fontWeight: 600 }}
            >
              {description}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default TrackingBanner;
